export default __webpack_public_path__ + "static/eztco-logo-07919480263b3b53e2176eb30b470555.png";